import { $AjaxJson } from '../lf'
import { $Urlpath, $UrlApipath } from '../config/config'


export const ChannelInfoRequest = {

    //渠道类型
    GetChannelType(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelType", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddChannelType(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelType", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelType(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelType", obj, function(d) {
            func(d)
        })
    },
    SearchChannelType(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelType", obj, function(d) {
            func(d)
        })
    },
    SetChannelTypeStatus(func, Status) {
        $AjaxJson($UrlApipath + "Channel/SetChannelTypeStatus", { Status: Status }, function(d) {
            func(d)
        })
    },

    //渠道
    GetChannelInfo(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelInfo", { ID: ID }, function(d) {
            func(d)
        })
    },
    //我的渠道删除
    DeleteChannelInfo(func, ID) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelInfo", { ID: ID }, function(d) {
            func(d)
        })
    },
    GetCustomerChannelInfo(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetCustomerChannelInfo", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddChannelInfo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelInfo", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelInfo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelInfo", obj, function(d) {
            func(d)
        })
    },
    SearchChannelInfo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelInfo", obj, function(d) {
            func(d)
        })
    },
    SearchCustomerChannelInfo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchCustomerChannelInfo", obj, function(d) {
            func(d)
        })
    },

    SetChannelInfoIsPublic(func, IsPublic) {
        $AjaxJson($UrlApipath + "Channel/SetChannelInfoIsPublic", { IsPublic: IsPublic }, function(d) {
            func(d)
        })
    },

    SetChannelInfoIsCubic(func, IsCubic) {
        $AjaxJson($UrlApipath + "Channel/SetChannelInfoIsCubic", { IsCubic: IsCubic }, function(d) {
            func(d)
        })
    },

    SetChannelInfoIsTracking(func, IsTracking) {
        $AjaxJson($UrlApipath + "Channel/SetChannelInfoIsTracking", { IsTracking: IsTracking }, function(d) {
            func(d)
        })
    },

    SetChannelInfoIsStorteEnable(func, IsStorteEnable) {
        $AjaxJson($UrlApipath + "Channel/SetChannelInfoIsStorteEnable", { IsStorteEnable: IsStorteEnable }, function(d) {
            func(d)
        })
    },

    SetChannelInfoIsAutoTrack(func, IsAutoTrack) {
        $AjaxJson($UrlApipath + "Channel/SetChannelInfoIsAutoTrack", { IsAutoTrack: IsAutoTrack }, function(d) {
            func(d)
        })
    },

    SetChannelInfoIsEnable(func, ID, IsEnable) {
        $AjaxJson($UrlApipath + "Channel/SetChannelInfoIsEnable", { ID: ID, IsEnable: IsEnable }, function(d) {
            func(d)
        })
    },


    //子货运方式管理
    GetSubChannelInfo(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetSubChannelInfo", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddSubChannelInfo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddSubChannelInfo", obj, function(d) {
            func(d)
        })
    },
    UpdateSubChannelInfo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateSubChannelInfo", obj, function(d) {
            func(d)
        })
    },
    SearchSubChannelInfo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchSubChannelInfo", obj, function(d) {
            func(d)
        })
    },
    SetSubChannelInfoIsCost(func, IsCost) {
        $AjaxJson($UrlApipath + "Channel/SetSubChannelInfoIsCost", { IsCost: IsCost }, function(d) {
            func(d)
        })
    },
    SetSubChannelInfoIsSale(func, IsSale) {
        $AjaxJson($UrlApipath + "Channel/SetSubChannelInfoIsSale", { IsSale: IsSale }, function(d) {
            func(d)
        })
    },
    SetSubChannelInfoStatus(func, Status) {
        $AjaxJson($UrlApipath + "Channel/SetSubChannelInfoStatus", { Status: Status }, function(d) {
            func(d)
        })
    },


    //子渠道分区
    GetChannelAreaInfo(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelAreaInfo", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddChannelAreaInfo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelAreaInfo", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelAreaInfo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelAreaInfo", obj, function(d) {
            func(d)
        })
    },
    SearchChannelAreaInfo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelAreaInfo", obj, function(d) {
            func(d)
        })
    },
    SetChannelAreaInfoIsMail(func, IsMail) {
        $AjaxJson($UrlApipath + "Channel/SetChannelAreaInfoIsMail", { IsMail: IsMail }, function(d) {
            func(d)
        })
    },
    DeleteChannelAreaInfo(func, ID) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelAreaInfo", { ID: ID }, function(d) {
            func(d)
        })
    },
    DeleteChannelAreaInfoList(func, IDs) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelAreaInfoList", { IDs: IDs }, function(d) {
            func(d)
        })
    },

    UploadChannelAreaInfo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UploadChannelAreaInfo", obj, function(d) {
            func(d)
        })
    },


    //分区报价
    GetChannelAreaPrice(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelAreaPrice", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddChannelAreaPrice(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelAreaPrice", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelAreaPrice(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelAreaPrice", obj, function(d) {
            func(d)
        })
    },
    SearchChannelAreaPrice(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelAreaPrice", obj, function(d) {
            func(d)
        })
    },
    DeleteChannelAreaPrice(func, obj) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelAreaPrice", obj, function(d) {
            func(d)
        })
    },

    DeleteChannelAreaPriceList(func, obj) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelAreaPriceList", obj, function(d) {
            func(d)
        })
    },
    UploadChannelAreaPrice(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UploadChannelAreaPrice", obj, function(d) {
            func(d)
        })
    },
    UploadChannelAreaPriceFee(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UploadChannelAreaPriceFee", obj, function(d) {
            func(d)
        })
    },



    //渠道特殊处理费
    GetChannelSpecialFee(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelSpecialFee", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddChannelSpecialFee(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelSpecialFee", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelSpecialFee(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelSpecialFee", obj, function(d) {
            func(d)
        })
    },
    SearchChannelSpecialFee(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelSpecialFee", obj, function(d) {
            func(d)
        })
    },
    DeleteChannelSpecialFee(func, obj) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelSpecialFee", obj, function(d) {
            func(d)
        })
    },
    UploadChannelSpecialFee(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UploadChannelSpecialFee", obj, function(d) {
            func(d)
        })
    },

    DeleteChannelSpecialFeeList(func, IDs) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelSpecialFeeList", { IDs: IDs }, function(d) {
            func(d)
        })
    },




    //渠道附加费表
    GetChannelSurcharge(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelSurcharge", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddChannelSurcharge(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelSurcharge", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelSurcharge(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelSurcharge", obj, function(d) {
            func(d)
        })
    },
    SearchChannelSurcharge(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelSurcharge", obj, function(d) {
            func(d)
        })
    },
    DeleteChannelSurcharge(func, ID) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelSurcharge", { ID: ID }, function(d) {
            func(d)
        })
    },


    //渠道套餐
    GetChannelMeal(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelMeal", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddChannelMeal(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelMeal", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelMeal(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelMeal", obj, function(d) {
            func(d)
        })
    },
    SearchChannelMeal(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelMeal", obj, function(d) {
            func(d)
        })
    },

    SetChannelMealIsEnable(func, ID, IsEnable) {
        $AjaxJson($UrlApipath + "Channel/SetChannelMealIsEnable", { ID: ID, IsEnable: IsEnable }, function(d) {
            func(d)
        })
    },

    //分配渠道
    SaveDistributionChannel(func, ID, IsEnable) {
        $AjaxJson($UrlApipath + "Channel/SaveDistributionChannel", { ID: ID, IsEnable: IsEnable }, function(d) {
            func(d)
        })
    },


    //下家公司

    GetNextCompany(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetNextCompany", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddNextCompany(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddNextCompany", obj, function(d) {
            func(d)
        })
    },
    UpdateNextCompany(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateNextCompany", obj, function(d) {
            func(d)
        })
    },
    SearchNextCompany(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchNextCompany", obj, function(d) {
            func(d)
        })
    },
    SearchNextCompanyByQ(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchNextCompanyByQ", obj, function(d) {
            func(d)
        })
    },
    SetNextCompanyStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "Channel/SetNextCompanyStatus", { ID: ID, Status: Status }, function(d) {
            func(d)
        })
    },

    //渠道跟踪号预录入
    GetChannelTrackingNo(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelTrackingNo", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddChannelTrackingNo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelTrackingNo", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelTrackingNo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelTrackingNo", obj, function(d) {
            func(d)
        })
    },
    SearchChannelTrackingNo(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelTrackingNo", obj, function(d) {
            func(d)
        })
    },

    SetChannelTrackingNoIsEnable(func, ID, IsEnable) {
        $AjaxJson($UrlApipath + "Channel/SetChannelTrackingNoIsEnable", { ID: ID, IsEnable: IsEnable }, function(d) {
            func(d)
        })
    },

    SetChannelTrackingNoIsUse(func, ID, IsUse) {
        $AjaxJson($UrlApipath + "Channel/SetChannelTrackingNoIsUse", { ID: ID, IsUse: IsUse }, function(d) {
            func(d)
        })
    },

    UploadChannelTrackingNo(func, data) {
        $AjaxJson($UrlApipath + "Channel/UploadChannelTrackingNo", data, function(d) {
            func(d)
        })
    },

    DeleteChannelTrackingNo(func, IDArr) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelTrackingNo", { IDArr: IDArr }, function(d) {
            func(d)
        })
    },



    //物流账号对接
    GetChannelApiSetUp(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelApiSetUp", { ID: ID }, function(d) {
            func(d)
        })
    },
    GetChannelApiSetUpBySubInfoID(func, SubChannelInfoID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelApiSetUpBySubInfoID", { SubChannelInfoID: SubChannelInfoID }, function(d) {
            func(d)
        })
    },

    AddChannelApiSetUp(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelApiSetUp", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelApiSetUp(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelApiSetUp", obj, function(d) {
            func(d)
        })
    },
    SearchChannelApiSetUp(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelApiSetUp", obj, function(d) {
            func(d)
        })
    },
    SetChannelApiSetUpIsReadSetUpSender(func, ID, IsReadSetUpSender) {
        $AjaxJson($UrlApipath + "Channel/SetChannelApiSetUpIsReadSetUpSender", { ID: ID, IsReadSetUpSender: IsReadSetUpSender }, function(d) {
            func(d)
        })
    },
    SetChannelApiSetUpIsEnable(func, ID, IsEnable) {
        $AjaxJson($UrlApipath + "Channel/SetChannelApiSetUpIsEnable", { ID: ID, IsEnable: IsEnable }, function(d) {
            func(d)
        })
    },



    //渠道预报方法
    GetChannelApiType(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelApiType", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddChannelApiType(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelApiType", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelApiType(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelApiType", obj, function(d) {
            func(d)
        })
    },
    SearchChannelApiType(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelApiType", obj, function(d) {
            func(d)
        })
    },
    DeleteChannelApiType(func, ID) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelApiType", { ID: ID }, function(d) {
            func(d)
        })
    },


    //渠道代码
    GetChannelApiDetailCode(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelApiDetailCode", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddChannelApiDetailCode(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelApiDetailCode", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelApiDetailCode(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelApiDetailCode", obj, function(d) {
            func(d)
        })
    },
    SearchChannelApiDetailCode(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelApiDetailCode", obj, function(d) {
            func(d)
        })
    },
    DeleteChannelApiDetailCode(func, ID) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelApiDetailCode", { ID: ID }, function(d) {
            func(d)
        })
    },


    //渠道订单配置
    GetChannelItemSetup(func, ID) {
        $AjaxJson($UrlApipath + "Channel/GetChannelItemSetup", { ID: ID }, function(d) {
            func(d)
        })
    },
    AddChannelItemSetup(func, obj) {
        $AjaxJson($UrlApipath + "Channel/AddChannelItemSetup", obj, function(d) {
            func(d)
        })
    },
    UpdateChannelItemSetup(func, obj) {
        $AjaxJson($UrlApipath + "Channel/UpdateChannelItemSetup", obj, function(d) {
            func(d)
        })
    },
    SearchChannelItemSetup(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelItemSetup", obj, function(d) {
            func(d)
        })
    },
    SearchChannelItemSetupList(func, obj) {
        $AjaxJson($UrlApipath + "Channel/SearchChannelItemSetupList", obj, function(d) {
            func(d)
        })
    },
    DeleteChannelItemSetup(func, ID) {
        $AjaxJson($UrlApipath + "Channel/DeleteChannelItemSetup", { ID: ID }, function(d) {
            func(d)
        })
    },

    SetChannelItemSetupItemType(func, ID, ItemType) {
        $AjaxJson($UrlApipath + "Channel/SetChannelItemSetupItemType", { ID: ID, ItemType: ItemType }, function(d) {
            func(d)
        })
    },
    SetChannelItemSetupIsRequest(func, ID, IsRequest) {
        $AjaxJson($UrlApipath + "Channel/SetChannelItemSetupIsRequest", { ID: ID, IsRequest: IsRequest }, function(d) {
            func(d)
        })
    },
    SetChannelItemSetupIsShow(func, ID, IsShow) {
        $AjaxJson($UrlApipath + "Channel/SetChannelItemSetupIsShow", { ID: ID, IsShow: IsShow }, function(d) {
            func(d)
        })
    },



}


// WEBPACK FOOTER //
// ./src/request/Channel.js